import "./App.css";
import "cdhs-ui-library/style.css";
import { Routes, Route } from "react-router";
import { useAppSelector } from "./store/store";

import Layout from "./components/Layout/Layout";

//Pages
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import Profile from "./Pages/Profile/Profile";
import Intro from "./Pages/StartInstructions/Intro";
import Survey from "./Pages/Survey/Survey";
import Contact from "./Pages/Contact/Contact";
import Submit from "./Pages/Submit/Submit";
import Congratulations from "./Pages/Congratulations/Congratulations";
import About from "./Pages/About/About";
import ErrorPage from "./Pages/ErrorPage/ErrorPage";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import PublicRoute from "./components/Auth/PublicRoute";
import { useEffect, useState } from "react";
import UrlParamInitializer from "./components/UrlParamInitializer/UrlParamInitializer";

function App() {
  const user = useAppSelector((state)=> state.user.user)
  const surveyType = user?.SurveyType == 17 ? "baseline": "follow-up";
  const [userAge, setUserAge] = useState<string>()
  const [incentiveValue, setIncentiveValue] = useState<string>();
  useEffect(()=>{
    console.log("INCENTIVE USE EFFECT", user?.SurveyType)
    if (user?.SurveyType == 17){

    setUserAge("17")

      setIncentiveValue("$25")

    }else if (user?.SurveyType == 2){
    setUserAge("19")

      setIncentiveValue("$35")
    }else if (user?.SurveyType == 3) {
    setUserAge("21")

      setIncentiveValue("$75")
    }
  }, [user?.SurveyType])
  return (
    <>
    <UrlParamInitializer/>
      <Routes>
        <Route element={<Layout />}>
            {/* General access paths */}
          <Route index element={<Home incentive={incentiveValue}/>} />
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />

          {/* Public routes (logged-out users only) */}
          <Route element={<PublicRoute />}>
            <Route path="user/login" element={<Login />} />
          </Route>

          {/* Protected routes (logged-in users only) */}
          <Route element={<ProtectedRoute />}>
            <Route path="user/profile" element={<Profile />} />
            <Route path="survey/start" element={<Intro incentive={incentiveValue}/>} />
            <Route path="survey/questions" element={<Survey />} />
            <Route path="survey/confirm" element={<Submit />} />
            <Route path="survey/thank-you" element={<Congratulations SurveyType={surveyType} incentive={incentiveValue} age={userAge}/>} />
          </Route>

          {/* Error handling */}
          <Route
            path="*"
            element={
              <ErrorPage />
            }
          />
        </Route>
      </Routes>
    </>
  );
}

export default App;
